<nb-accordion multi class="custom-accordion mt-0">
  <!-- ENERGY OBJECTIVES -->
  <nb-accordion-item expanded>
    <nb-accordion-item-header>
      <span class="text">{{ "Energy objectives" | translate }}</span>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <table class="table">
        <thead>
          <tr>
            <th class="w-20 align-middle">{{ "Building" | translate }}</th>
            <th class="align-middle">{{ "Year" | translate }}</th>
            <th class="align-middle">{{ "Surface (m2) for energy ratios" | translate }}</th>
            <th class="align-middle">{{ "Objective type" | translate }}</th>
            <th class="align-middle">{{ "Objective in kWh EF / m2" | translate }}</th>
            @if (!readOnly) {
              <th class="align-middle"></th>
            }
          </tr>
        </thead>
        <tbody>
          @if (energyObjectives.length > 0) {
            @for (objective of energyObjectives; track objective.id) {
            <tr>
              <td class="align-middle">{{ objective.building }}</td>
              <td class="align-middle">{{ objective.year }}</td>
              <td class="align-middle">{{ objective.surface | number }} m²</td>
              <td class="align-middle">{{ objective.objectiveType }}</td>
              <td class="align-middle">{{ objective.objectiveValue }} kWh EF / m²</td>
              @if (!readOnly) {
                <td class="align-middle">
                  <div class="header-icons">
                    <button class="btn btn-sm btn-outline-danger" (click)="editEnergyObjective(objective)">
                      <i class="fa-thin fa-pen-to-square"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="confirmDeleteEnergyObjective(objective)">
                      <i class="fa-thin fa-trash-can"></i>
                    </button>
                  </div>
                </td>
              }
            </tr>
            }
          } @else {
            <tr>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              @if (!readOnly) {
                <td class="align-middle"></td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (!readOnly) {
        <div class="add-objective-container">
          <a class="add-objective-button" (click)="addEnergyObjective()">
            (+)
            <span>{{ "Add energy objective" | translate }}</span>
          </a>
        </div>
      }
    </nb-accordion-item-body>
  </nb-accordion-item>

  <!-- CARBON OBJECTIVES -->
  <nb-accordion-item expanded>
    <nb-accordion-item-header>
      <span class="text">{{ "Carbon objectives" | translate }}</span>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <table class="table">
        <thead>
          <tr>
            <th class="w-20 align-middle">{{ "Building" | translate }}</th>
            <th class="align-middle">{{ "Year" | translate }}</th>
            <th class="align-middle">{{ "Surface (m2) for carbon ratios" | translate }}</th>
            <th class="align-middle">{{ "Objective type" | translate }}</th>
            <th class="align-middle">{{ "Objective in kg eq CO2 / m2" | translate }}</th>
            @if (!readOnly) {
              <th class="align-middle"></th>
            }
          </tr>
        </thead>
        <tbody>
          @if (carbonObjectives.length > 0) {
            @for (objective of carbonObjectives; track objective.id) {
            <tr>
              <td class="align-middle">{{ objective.building }}</td>
              <td class="align-middle">{{ objective.year }}</td>
              <td class="align-middle">{{ objective.surface | number }} m²</td>
              <td class="align-middle">{{ objective.objectiveType }}</td>
              <td class="align-middle">{{ objective.objectiveValue }} kg eq. CO2 / m²</td>
              @if (!readOnly) {
                <td class="align-middle">
                  <div class="header-icons">
                    <button class="btn btn-sm btn-outline-danger" (click)="editCarbonObjective(objective)">
                      <i class="fa-thin fa-pen-to-square"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="confirmDeleteCarbonObjective(objective)">
                      <i class="fa-thin fa-trash-can"></i>
                    </button>
                  </div>
                </td>
              }
            </tr>
            }
          } @else {
            <tr>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              @if (!readOnly) {
                <td class="align-middle"></td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (!readOnly) {
        <div class="add-objective-container">
          <a class="add-objective-button" (click)="addCarbonObjective()">
            (+)
            <span>{{ "Add carbon objective" | translate }}</span>
          </a>
        </div>
      }
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
